import {
  NotificationCategory,
  NotificationType,
} from "@virtualprogaming/js-public-sdk";
import { forEach } from "lodash";
import { filter } from "lodash-es";
import { useCallback } from "react";

import {
  useChatConversationMembers,
  useSendNotificationToAll,
} from "~/queries";
import { useChatAuthAccessToken } from "~/ui/context";
import { useCurrentUser } from "~/utils";

export const useSendNotificationsToAllChatMembers = (chatId: number) => {
  const currentUser = useCurrentUser();
  const accessToken = useChatAuthAccessToken();

  const { mutateAsync: sendNotification } = useSendNotificationToAll();

  const { data: members } = useChatConversationMembers(
    chatId,
    accessToken,
    1000
  );

  const sendNotificationToAllMembers = useCallback(
    (message: string) => {
      if (members?.data) {
        const users = filter(
          members.data,
          (member) =>
            Number(member?.uid?.substring(1)) !== currentUser?.user_id &&
            member?.display_name !== currentUser?.username
        );
        forEach(users, ({ uid }) => {
          if (!uid) {
            return;
          }

          sendNotification([
            Number(uid.substring(1)),
            {
              title: `${currentUser?.username} sent a message.`,
              body: `Message: ${message}`,
              type: NotificationType.MessageReceived,
              category: NotificationCategory.Chat,
              url: chatId.toString(),
              obj_id: chatId.toString(),
            },
          ]);
        });
      }
    },
    [chatId, currentUser, members?.data, sendNotification]
  );

  return { sendNotificationToAllMembers };
};
